import React from 'react'

import { returnTimeline } from 'artkive/components/sections/GetStartedWithBox/GetStartedWithBox'

import { GetStarted, NoticeTitle } from './KeepsakeGetStarted.style'

const KeepsakeGetStarted = () => (
  <GetStarted caption={null} noticeTitle={<NoticeTitle gutterBottom>{returnTimeline}</NoticeTitle>} />
)

export default KeepsakeGetStarted
